<template>
  <div class="guide-container">
    <div class="carousel-content">
      <div
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        class="guide-header-title-container"
      >
        <h4>Vår</h4>
        <h2 class="guide-header-title">Produktguide</h2>
        <img class="guide-title-logo" :src="menu" />
      </div>
    </div>

    <div class="guide-content">
      <!-- <div class="hidden-element">
        <menu-category-view></menu-category-view>
      </div> -->
      <div
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="200"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        class="intro-text"
      >
        <div class="intro-textblock">
          <p>
            Sushi er en japansk matrett som består av shari (kokt ris
            tradisjonelt tilsatt risvineddik, sukker og salt), ofte bestående av
            rå fisk og annen sjømat. <br />Sushi blir tradisjonelt sett servert
            sammen med soyasaus kalt murasaki, syltet ingefær kalt gari,
            oppkvernet japansk pepperrot kalt wasabi, og grønn te kalt agari.
            <br />Rå fisk alene blir ikke kalt sushi, men Sashimi. Vi serverer
            sashimi med ris på side og ponzusaus.
          </p>
          <br />
          <div class="accessories-images">
            <img :src="ponzu" />
            <img :src="ginger" />
            <img :src="gokame" />
            <img :src="kimchi" />
          </div>

          <p>
            <br />Scroll nedover og lær mer om de forskjellige typer sushi vi
            tilbyr
          </p>
        </div>
        <hr />
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-mix"
        >
          <img :src="godtblandet" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Godt og blandet</h3>
            <p class="pr-text">
              Her setter vi sammen nigiri, maki og sashimi i en meny av
              forskjellige størrelser. Til lunsj anbefales 8-12 biter. Meny
              1-2B. Til middag anbefales 16-26 biter. Meny 3 -5B. Middag for 2
              anbefales meny nr 5 eller 5B. Meny nr 5: Fuji Drøm består av 14
              nigiri og 12 futomaki Meny nr 5B: Fuji Kombi består av 7 nigiri,
              10 sashimi og 8 uramaki
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content right">
        <div
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image-right calligraphy-uramaki"
        >
          <img :src="uramaki" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper-right">
            <h3 class="pr-title">Uramaki</h3>
            <p class="pr-text">
              Uramaki er en makirull som har risen ytterst, med sesamfrø og
              sjøgresset rullet rundt ingrediensene i midten. Rullen er mindre
              og kjæres i 8 biter.
            </p>
            <button class="fancy right-float">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="150"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-futomaki"
        >
          <img :src="futomaki" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Futomaki</h3>
            <p class="pr-text">
              Futomaki er en tykk versjon av makisushi, og har tradisjonelt sett
              flere ingredienser i midten av rullen i tillegg til ris. Tangen er
              pakket utenfor og vi deler disse i 12 biter.
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>

      <div v-prlx.background="{ speed: 0.02 }" class="section-image">
        <img :src="east" class="image-overlap" />
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="200"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-mix"
        >
          <img :src="kaburimaki" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="150"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Kaburimaki</h3>
            <p class="pr-text">
              Ligner på uramaki, men i tillegg topper rullen med rå fisk .
              Ingrediensene i midten kan være avokado, agurk, rå og kokt eller
              stekt fisk og skalldyr. I meny nr 16, 16F og16G.
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content right">
        <div
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="250"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image-right calligraphy-uramaki"
        >
          <img :src="fujistyle" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="150"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper-right">
            <h3 class="pr-title">Fuji-Style Maki</h3>
            <p class="pr-text">
              Fuji Specialmaki er sunnere enn sunt. Ingrediensene rulles i tynt,
              gjennomsiktige rispapir. Insiden består av rå laks, fritert
              scampi, krabbe eller kylling, agurk, avokado, salat, wasabimajones
              og flyvefiskrogn. Kuttes i 10 biter
            </p>
            <button class="fancy right-float">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-futomaki"
        >
          <img :src="sashimi" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Sashimi</h3>
            <p class="pr-text">
              Rå fisk alene blir ikke kalt sushi, men Sashimi. Vi serverer
              sashimi med ris på siden og ponzusaus.
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-prlx.background="{
          speed: 0.09
        }"
        class="section-image-second"
      >
        <img :src="fresh" class="image-overlap" />
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="400"
          data-aos-delay="200"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-mix"
        >
          <img :src="nigiri" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="300"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Nigiri</h3>
            <p class="pr-text">
              Nigiri er en avlang risball som er mindre enn lengden til en
              håndflate, tradisjonelt med en topping (neta) kuttet i en tynn
              skive. Vanlig topping er ulike typer rå fisk, rå og kokte
              skalldyr.
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content right">
        <div
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image-right calligraphy-uramaki"
          style="background-position-x: 260px"
        >
          <img :src="pokebowl" style="max-height: 500px; height: 100%" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper-right">
            <h3 class="pr-title">Pokebowl</h3>
            <p class="pr-text">
              Poke betyr "å skive eller kutte" på hawaiisk og refererer til
              biter av rå, marinert fisk-vanligvis tunfisk eller laks-som
              deretter blir kastet over ris og toppet med grønnsaker og
              umami-pakket sauser. Hos oss har vi mange spennende og deilige
              pokebowls, velg mellom tempura scampi, tofu, kylling og mer.
            </p>
            <button class="fancy right-float">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pr-content">
        <div
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-image calligraphy-futomaki"
        >
          <img :src="tofu" />
        </div>
        <div
          data-aos="fade"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          class="pr-description"
        >
          <div class="desc-wrapper">
            <h3 class="pr-title">Vegetar</h3>
            <p class="pr-text">
              Vi har laget en meny med en rekke vegetarretter i alle kategoriene
              - fra maki til pokebowls! Vi bruker blant annet Seitan, en
              plantebasert kjøttalternativ, men er laget av gluten. Må prøves!
            </p>
            <button class="fancy">
              <span class="top-key"></span>
              <a @click="handleButtonClick()">Bestill nå</a>
              <span class="bottom-key-1"></span>
              <span class="bottom-key-2"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuCategoryView from "../menus/MenuCategoryView.vue";
export default {
  components: { MenuCategoryView },
  name: "ProductGuideNew",

  data() {
    return {
      menu: require("@/assets/images/calli-great.png"),
      uramaki: require("@/assets/images/uramaki.png"),
      futomaki: require("@/assets/images/futomaki.png"),
      kaburimaki: require("@/assets/images/kaburimaki.png"),
      fujistyle: require("@/assets/images/fujistyle.png"),
      sashimi: require("@/assets/images/sashimi.png"),
      godtblandet: require("@/assets/images/godtblandet.png"),
      nigiri: require("@/assets/images/nigiri.png"),
      pokebowl: require("@/assets/images/pokebowl.png"),
      ginger: require("@/assets/images/ginger-guide.png"),
      gokame: require("@/assets/images/gress-guide.png"),
      ponzu: require("@/assets/images/ponzu-guide.png"),
      kimchi: require("@/assets/images/kimchi-guide.png"),
      east: require("@/assets/images/calligraphy-east.png"),
      fresh: require("@/assets/images/calligrqaphy-fresh.png"),
      tofu: require("@/assets/images/tofumaki.png")
    };
  },

  methods: {
    handleButtonClick() {
      this.$router.push("/restaurants");
    }
  }
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.guide-container {
  line-height: 30px;
  font-family: "Roboto";
  overflow-x: hidden;

  @media (max-width: $mobile) {
    margin-right: 0;
    margin-left: 0;
    overflow-x: hidden;
  }
}
.carousel-content {
  height: 490px;
  width: 100%;

  background-image: url("~@/assets/images/h-5-slider-img-1.jpg");
  background-position: 0px -37px, 0px 0px;
  background-size: cover;
  object-fit: cover;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 200px;
  }
}
.section-image {
  height: 490px;
  width: 100%;
  margin-top: 8em;
  background-image: url("~@/assets/images/shutterstock_1504638182.jpg");
  background-position: 0px -155px, 0px 0px;
  background-size: cover;
  object-fit: cover;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;

  @media (max-width: $mobile) {
    height: 241px;
    background-position: initial;
  }
}
.section-image-second {
  height: 490px;
  width: 100%;
  margin-top: 8em;
  background-image: url("~@/assets/images/shutterstock_1861264615.jpg");
  background-position: 0px -400px, 0px 0px;
  background-size: cover;
  object-fit: cover;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;

  @media (max-width: $mobile) {
    height: 241px;
    background-position: initial;
  }
}

.image-overlap {
  position: absolute;

  height: 600px;
  @media (max-width: $mobile) {
    height: auto;
  }
}
.guide-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0;
  font-size: 2vw;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
  @media (min-width: $tablet) {
    font-size: 40px;
  }
}

.guide-header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }

  @media (min-width: $tablet) {
    height: 200px;
    width: 310px;
    border-radius: 30px;
  }
}

.guide-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 60px;
    width: auto;
  }
}
h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
  @media (min-width: $tablet) {
    font-size: 17px;
  }
}
.pr-image {
  width: 90%;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: -12px 20px;
  margin-left: 9%;
  @media (max-width: 1536px) {
    margin: 0 5em;
  }
  @media (max-width: $mobile) {
    margin: 0 1em;
  }
}
.calligraphy-mix {
  background-image: url("~@/assets/images/calligraphy1.png");
}

.calligraphy-futomaki {
  background-image: url("~@/assets/images/calligraphy4.png");
  background-size: 400px;
  background-position: -15px -5px;
}
.pr-image-right {
  width: 90%;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: 375px -19px;
  margin: 0 5em;

  @media (max-width: $mobile) {
    width: 100%;
    background-position: initial;
    display: flex;
    justify-content: center;
    margin: 0;
  }
}

.calligraphy-uramaki {
  background-image: url("~@/assets/images/calligraphy3.png");
}
.right {
  flex-direction: row-reverse;
}
.pr-description {
  height: 100%;
  width: 100%;
}
.pr-title {
  font-size: 35px;
  font-family: bebas;
}
.pr-text {
  color: #878787;
  font-size: 18px;

  @media (max-width: $mobile) {
    margin: 0 1em;
  }
}
.guide-content {
  margin: 5% 0;
}
.pr-content {
  display: flex;
  justify-content: center;
  margin-top: 5%;

  @media (max-width: $mobile) {
    flex-direction: column;
    margin-top: 20%;
  }

  & img {
    max-height: 435px;
    width: auto;
    max-width: 100%;
    @media (max-width: $mobile) {
      max-height: 230px;
    }
  }
}

.desc-wrapper {
  padding: 100px 350px 0 0;

  @media (max-width: 1536px) {
    padding: 65px 235px 0 0;
  }

  @media (max-width: $mobile) {
    padding: 0;
    text-align: center;
  }
}

.desc-wrapper-right {
  padding: 100px 0 0 350px;
  text-align: right;
  @media (max-width: 1536px) {
    padding: 65px 0 0 200px;
  }
  @media (max-width: $mobile) {
    padding: 0;
    text-align: center;
  }
}

.intro-text {
  margin-top: 150px;
  & hr {
    border-bottom: 1px solid #c5c5c5;
    -webkit-box-shadow: 0 20px 20px -20px #333;
    box-shadow: 0 20px 20px -20px #333;
    border: none;
    height: 43px;
    position: relative;
    border-radius: 100%;
  }
  @media (max-width: $mobile) {
    margin-top: 50px;
  }
}

.accessories-images img {
  height: 245px;
  width: auto;

  @media (max-width: $laptop) {
    height: 150px;
  }
  @media (max-width: $mobile) {
    height: 145px;
  }
}

.h1-guide {
  text-align: center;
  font-family: Bebas;
}

.intro-textblock {
  margin-top: 35px;
  margin-right: 0px;
  padding-right: 150px;
  padding-left: 150px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-indent: 0px;
  text-transform: none;
  letter-spacing: 0.5px;

  @media (max-width: $mobile) {
    padding-right: 40px;
    padding-left: 40px;
  }
}

.blk-button {
  width: 180px;
  padding: 18px;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  font-family: Bebas;
  font-size: 18px;
  vertical-align: bottom;

  &.btn-pay {
    width: 100%;
    margin-top: 16px;
    @media (max-width: $mobile) {
      font-size: 20px;
      padding: 10px;
    }
  }

  @media (max-width: $mobile) {
    padding: 2px;
    width: 94px;
    font-size: 14px;
  }

  &:hover {
    background: #000000 !important;
    color: #ffffff !important;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
}
.right-float {
  float: right !important;
  @media (max-width: $mobile) {
    float: initial !important;
  }
}
button.fancy {
  -webkit-appearance: button;
  background-color: transparent;
  border: 2px solid #000;
  border-radius: 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  float: left;
  font-family: Bebas;
  font-weight: 400;
  letter-spacing: 1px;
  margin-top: 1em;
  outline: none;
  overflow: visible;
  padding: 1.25em 2em;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: none;
  transition: all 0.3s ease-in-out;
  user-select: none;
  width: 10.8125rem;
  @media (max-width: $mobile) {
    float: initial !important;
  }
  &::before {
    content: " ";
    width: 1.5625rem;
    height: 2px;
    background: black;
    top: 50%;
    left: 1.5em;
    position: absolute;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transition: background 0.3s linear, width 0.3s linear;
    transition: background 0.3s linear, width 0.3s linear;
  }

  a {
    font-size: 1em;
    line-height: 1.33333em;
    padding-left: 2em;
    display: block;
    text-align: left;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    text-transform: uppercase;
    text-decoration: none;
    color: black;
  }

  .top-key {
    height: 2px;
    width: 1.5625rem;
    top: -2px;
    left: 0.625rem;
    position: absolute;
    background: white;
    -webkit-transition: width 0.5s ease-out, left 0.3s ease-out;
    transition: width 0.5s ease-out, left 0.3s ease-out;
  }

  .bottom-key-1 {
    height: 2px;
    width: 1.5625rem;
    right: 1.875rem;
    bottom: -2px;
    position: absolute;
    background: white;
    -webkit-transition: width 0.5s ease-out, right 0.3s ease-out;
    transition: width 0.5s ease-out, right 0.3s ease-out;
  }
  .bottom-key-2 {
    height: 2px;
    width: 0.625rem;
    right: 0.625rem;
    bottom: -2px;
    position: absolute;
    background: white;
    -webkit-transition: width 0.5s ease-out, right 0.3s ease-out;
    transition: width 0.5s ease-out, right 0.3s ease-out;
  }

  &:hover {
    color: white;
    background: black;

    &::before {
      width: 0.9375rem;
      background: white;
    }

    a {
      color: white;
      padding-left: 1.5em;
    }

    .top-key {
      left: -2px;
      width: 0px;
    }
    .bottom-key-1,
    .bottom-key-2 {
      right: 0;
      width: 0;
    }
  }
}
</style>
